import { render, staticRenderFns } from "./buscaPagoComponent.vue?vue&type=template&id=264c26fd&scoped=true"
import script from "./buscaPagoComponent.vue?vue&type=script&lang=js"
export * from "./buscaPagoComponent.vue?vue&type=script&lang=js"
import style0 from "./buscaPagoComponent.vue?vue&type=style&index=0&id=264c26fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c26fd",
  null
  
)

export default component.exports